module.exports = __webpack_public_path__ + "static/media/UHS Logo.080bd320.png";